import {
  arrayOf,
  shape,
  string,
  number,
} from 'prop-types';

export const addressType = shape({
  countryId: number,
  region: string,
  city: string,
  postalCode: string,
  streetNumber: string,
});

export const identificationType = shape({
  number: string.isRequired,
});

export const watchListEntryType = shape({
  addresses: arrayOf(addressType),
  identifications: arrayOf(identificationType),
  comment: string,
});


// WEBPACK FOOTER //
// ./src/prop-types/watchListTypes.js